'use strict';

var _ = require('lodash');
var ConfigurationParametersAdvancedService = function ConfigurationParametersAdvancedService($log, featureToggleService, configurationService, app) {
  var configs = require('../config/configuration-parameters-advanced.json');
  var properties = require('../config/configuration-parameters-advanced-properties.json');
  var infoTooltipMessages = require('../config/configuration-parameters-advanced-info-tooltip.json');
  var csvExportOrder = require('../config/configuration-parameters-advanced-csv-export.json');
  var preparedConfigs;
  function adjustRendererLinkTextBasingOnLevelReadOnly(levelConfig) {
    var linkProperty = _.find(levelConfig.properties, {
      renderer: 'cellLink'
    });
    if (levelConfig.readOnly && !_.isUndefined(linkProperty)) {
      linkProperty.columnMetadata.linkText = linkProperty.columnMetadata.linkText.replace('Set', 'View');
    }
  }
  function mappingCabinToAirlineService(cabin) {
    var cabinConfig = _.find(app.cabinsConfig, function (cabinConfig) {
      return cabinConfig.cabinCode === cabin;
    });
    return _.get(cabinConfig, 'cabinName', '');
  }
  function generateCabinColumnsForFpMarketConfig(levelConfig) {
    var availableCabins = configurationService.getCabins();
    var cabinColumnsGroup = _.find(levelConfig.properties, {
      groupId: 'benchmarkCarrier'
    });
    var templateCabinColumn = _.cloneDeep(cabinColumnsGroup.columns[0]);
    cabinColumnsGroup.columns = [];
    _.forEach(availableCabins, function (cabin) {
      var cabinColumn = _.cloneDeep(templateCabinColumn);
      cabinColumn.field += cabin;
      cabinColumn.title = mappingCabinToAirlineService(cabin);
      cabinColumnsGroup.columns.push(cabinColumn);
    });
  }
  function generateCabinColumnsForCurtainRule(levelConfig) {
    var availableCabins = configurationService.getCabins();
    var cabinOptionsArray = _.find(levelConfig.properties, {
      field: 'curtainRuleParam_cabinOptions'
    });
    var templateCabin = _.cloneDeep(cabinOptionsArray.columnMetadata.columns[1]);
    cabinOptionsArray.columnMetadata.columns[1] = {};
    _.forEach(availableCabins, function (cabin) {
      var cabinOptionsColumn = _.cloneDeep(templateCabin);
      cabinOptionsColumn.field += cabin;
      cabinOptionsColumn.title += cabin;
      cabinOptionsArray.columnMetadata.columns.push(cabinOptionsColumn);
    });
  }
  function generateDynamicColumns(levelConfig) {
    if (levelConfig.type === 'FP_MarketConfig') {
      generateCabinColumnsForFpMarketConfig(levelConfig);
    } else if (levelConfig.type === 'CurtainRule') {
      generateCabinColumnsForCurtainRule(levelConfig);
    }
  }
  function getPreparedConfigs(configType) {
    if (!_.isUndefined(configType)) {
      preparedConfigs = _.filter(configs, function (config) {
        return config.configType === configType && featureToggleService.isEnabled(config.showIfFeature);
      });
    } else {
      preparedConfigs = _.filter(configs, function (config) {
        return featureToggleService.isEnabled(config.showIfFeature);
      });
    }
    _.forEach(preparedConfigs, function (c) {
      c.properties = _.chain(properties).cloneDeep().find(['type', c.type]).get('properties').filter(function (field) {
        if (!field.hasOwnProperty('field') === null) {
          return true;
        }
        return isFieldVisibleByFeature(field);
      }).value();
      generateDynamicColumns(c);
      adjustRendererLinkTextBasingOnLevelReadOnly(c);
    });
    return preparedConfigs;
  }
  function isFieldVisibleByFeature(field) {
    return field.hasOwnProperty('showIfFeature') && featureToggleService.isEnabled(field.showIfFeature) || !field.hasOwnProperty('showIfFeature');
  }
  var getConfigs = function getConfigs(configType) {
    return getPreparedConfigs(configType);
  };
  var getInfoTooltipMessage = function getInfoTooltipMessage(type) {
    if (!infoTooltipMessages[type]) {
      return '';
    }
    return infoTooltipMessages[type];
  };
  var getCsvExportOrder = function getCsvExportOrder(type) {
    return _.find(csvExportOrder, {
      type: type
    });
  };
  var extractSeasonDetails = function extractSeasonDetails() {
    var seasons = [];
    var seasonsAbbreviationMap = {};
    var seasonsAbbreviation = [];
    var seasonDefinitions = configurationService.getFoSeasonDefinitions();
    _.map(seasonDefinitions, function (seasonDefinition) {
      seasonsAbbreviation.push(seasonDefinition.seasonAbbreviation);
      seasons.push(seasonDefinition.season);
      seasonsAbbreviationMap[seasonDefinition.seasonAbbreviation] = seasonDefinition.season;
    });
    return {
      seasonsAbbreviation: seasonsAbbreviation,
      seasons: seasons,
      seasonDefinitions: seasonDefinitions,
      seasonsAbbreviationMap: seasonsAbbreviationMap
    };
  };
  return {
    getConfigs: getConfigs,
    getInfoTooltipMessage: getInfoTooltipMessage,
    getCsvExportOrder: getCsvExportOrder,
    extractSeasonDetails: extractSeasonDetails
  };
};
ConfigurationParametersAdvancedService.$inject = ['$log', 'FeatureToggleService', 'ConfigurationService', 'App'];
module.exports = ConfigurationParametersAdvancedService;